module.exports = __webpack_public_path__ + "static/media/ic_canvas_disable.b57faa3f.svg";